export default __webpack_public_path__ + "static/media/Radomir-Tinkov-Gilroy-Heavy-9.401eb832.otf";